import React from 'react';
import { IconContainer } from './style';
import { OFFER_ICON } from '../../reducers/offer';
import { ReactComponent as Flame } from "../../static/images/flame.svg";
import { ReactComponent as Plug } from "../../static/images/plug.svg";

export default ({
    icon
}) => (
        <IconContainer>
            {icon && icon === OFFER_ICON.both &&
                <React.Fragment>
                    <Plug />
                    <Flame />
                </React.Fragment>
            }
            {icon && icon === OFFER_ICON.energy &&
                <React.Fragment>
                    <Plug />
                </React.Fragment>
            }
            {icon && icon === OFFER_ICON.gas &&
                <React.Fragment>
                    <Flame />
                </React.Fragment>
            }
        </IconContainer>
    )